export default __webpack_public_path__ + "static/media/warning.855150af.svg";